module.exports = __webpack_public_path__ + "img/course1.61504c8f.png";